export default "__VITE_ASSET__B45pkW8Q__"